(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["af-pillow-insert"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('af-pillow-insert')) {
  customElements.define('af-pillow-insert', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.productForm = this.closest('product-form');
      this.checkbox = this.querySelector('[data-af-insert]');
      if (!this.form || !this.productForm || !this.checkbox || theme.settings.afterAddToCart === 'no-js') return;
      this.checkbox.checked = false;
      this.querySelector('label').hidden = false;
      this.syncPayment = () => {
        const payment = this.form.querySelector('.product-dynamic-payment-button');
        if (payment) payment.hidden = this.checkbox.checked;
      };
      this.onChange = (event) => {
        if (event.target.closest('variant-picker')) {
          this.productForm.dataset.afInsertPending = 'true';
          this.checkbox.checked = false;
          this.checkbox.disabled = true;
          this.syncPayment();
        }
      };
      this.onVariant = () => {
        delete this.productForm.dataset.afInsertPending;
        this.checkbox.disabled = false;
        this.syncPayment();
      };
      this.checkbox.addEventListener('change', this.syncPayment);
      this.productForm.addEventListener('change', this.onChange, true);
      this.productForm.addEventListener('on:variant:change', this.onVariant);
      this.syncPayment();
    }
    disconnectedCallback() {
      this.checkbox?.removeEventListener('change', this.syncPayment);
      this.productForm?.removeEventListener('change', this.onChange, true);
      this.productForm?.removeEventListener('on:variant:change', this.onVariant);
      const payment = this.form?.querySelector('.product-dynamic-payment-button');
      if (payment) payment.hidden = false;
      if (this.productForm) delete this.productForm.dataset.afInsertPending;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
